// extracted by mini-css-extract-plugin
export default {"logo-input-container":"styles_logo-input-container__vEP8s"};